import gql from 'graphql-tag';
export default gql`
  query models($params: VehicleQuery) {
    models(params: $params) {
      id
      name
      makeName
      transmissionGroups {
        id
        name
      }
      variants {
        id
        imageUrl
        listPrice
        listPriceGross
        modelYear
        trim
        derivative
        fuelType
        transmission
        transmissionGroupId
        engineDescription
        driveTrain
        seats
      }
    }
  }
`;
